function sliderPrivateLabel() {
    const swiperContainer = document.querySelector('.privatelabel_swiper-js');

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: true,
        delay: 4000,
        speed: 1000,
        pagination: false,
        navigation: false,
    });
}

$(function() {
    sliderPrivateLabel();
});